import React from "react";
import NextLink from "next/link";
import PropTypes from "prop-types";
import {
  Box,
  Drawer,
  useMediaQuery,
  List,
  Link,
  Button,
  Typography,
  ListItem,
  Collapse,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import LogoIcon from "../../logo/LogoIcon";
import Menuitems from "./MenuItems";
import AdminMenu from "./AdminMenu";
import { useRouter } from "next/router";
import { StarBorder } from "@mui/icons-material";
import HeaderModal from "../../Modal/HeaderModal";
import QrModal from "../../Modal/QrModal";
import { onGetStripeLogin } from "../../../src/utils/queries";
import { useAuthProvider } from "../../../context/AuthProvider";
import toast from "react-hot-toast";
import StripeModal from "../../Modal/StripeModal";
import ContactModal from "../../Modal/ContactModal";

const Sidebar = ({ isMobileSidebarOpen, onSidebarClose, isSidebarOpen }) => {
  const [open, setOpen] = React.useState(false);
  const [openStripe, setOpenStripe] = React.useState(false);
  const [openDD, setOpenDD] = React.useState(null);

  const [link, setLink] = React.useState("");

  const { user } = useAuthProvider();

  const isNotAdmin = user && user?.role?.id < 2 ? true : false;

  const handleClickDD = (index) => {
    if (openDD === index) {
      setOpenDD((prevopen) => !prevopen);
    } else {
      setOpenDD(index);
    }
  };

  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const handleClick = (index) => {
    if (open === index) {
      setOpen((prevopen) => !prevopen);
    } else {
      setOpen(index);
    }
  };


  //fix the issue of the sidebar menus going to stripe even though the stripe tab has been closed.
  const callback = (param) => {
    switch (param) {
      case "QR":
        openModal();
        break;
      case "ROUTE":
        stripeRoute();
        break;
      case "id":
        copy();
        break;
      default:
        console.log("No action defined for this menu item.");
        break;
    }
  };

  const copy = () => {
    navigator.clipboard.writeText(user?.donee_code || "");
    toast.success("ID copied successfully!!", {
      position: "bottom-center",
    });
  };

  const stripeRoute = () => {
    // window.location.assign(link)
    // window.open(link, "_blank");
    setOpenStripe(true);
  };



  const openModal = () => {
    setOpen(true);
  };



  let curl = useRouter();
  const location = curl.pathname;

  const isAdmin = location.includes("/admin");
  const SidebarContent = (
    <Box
      p={2}
      height="100%"
      display={"flex"}
      flexDirection="column"
      justifyContent={"space-between"}
      displayPrint="none"
    >
      {/* <LogoIcon /> */}
      <Box mt={2}>
        <List sx={{ mb: "2.75em" }}>
          {isAdmin
            ?
            AdminMenu.map((Menuitem, index) => (
              <Box key={`admin-menu-${index}`} sx={{ mb: "2em" }}>
                <Typography
                  sx={{
                    marginLeft: "1.5em",
                    fontSize: "10px",
                    marginY: "12px",
                  }}
                >
                  {Menuitem.subHead}
                </Typography>
                <List component="li" disablePadding>
                  {Menuitem.content.map((item, i) =>
                    !item.group ? (
                      <NextLink key={item.href || i} href={item.href ? item.href : ""}>
                        <ListItem
                          onClick={() => item.action && callback(item.action)}
                          button
                          selected={location === item.href}
                          sx={{
                            margin: "none",
                            ...(location === item.href && {
                              color: "primary.main",
                              backgroundColor: (theme) =>
                                `${theme.palette.grey.bg20}!important`,
                              borderLeft: (theme) =>
                                `2px solid ${theme.palette.primary.main}`,
                              borderRadius: "0px 8px 8px 0px",
                            }),
                          }}
                        >
                          {item.icon && (
                            <ListItemIcon>
                              <i
                                className={item.icon}
                                style={{
                                  color: `${location === item.href ? "#2962FF" : ""}`,
                                }}
                              ></i>
                            </ListItemIcon>
                          )}

                          <ListItemText
                            disableTypography
                            sx={{ margin: 0 }}
                            primary={
                              <>
                                <Typography
                                  variant="big"
                                  sx={{
                                    color: `${location === item.href ? "#2962FF" : ""}`,
                                  }}
                                >
                                  {item.title === "id" ? user?.donee_code : item.title}
                                </Typography>
                                {item.icon_right && (
                                  <i
                                    className={item.icon_right}
                                    style={{
                                      marginLeft: "1em",
                                      color:
                                        location === item.href
                                          ? "#2962FF"
                                          : item.icon_color || "",
                                    }}
                                  ></i>
                                )}
                              </>
                            }
                            onClick={onSidebarClose}
                          ></ListItemText>
                        </ListItem>
                      </NextLink>
                    ) : (
                      <div key={`admin-group-${i}`}>
                        <ListItemButton
                          onClick={() => handleClickDD(i)}
                          sx={{
                            boxShadow: openDD && "inset 1px 0px 0px #C4CBD4",
                            margin: "none",
                            paddingY: "4px",
                          }}
                        >
                          <ListItemIcon>
                            <i
                              className={item.icon}
                              style={{
                                color: `${location === item.href ? "#2962FF" : ""}`,
                              }}
                            ></i>
                          </ListItemIcon>
                          <ListItemText
                            primary={
                              <>
                                <Typography variant="big">
                                  {item.title === "id" ? user?.donee_code : item.title}
                                </Typography>
                                {item.icon_right && (
                                  <i
                                    className={item.icon_right}
                                    style={{ marginLeft: "1em" }}
                                  ></i>
                                )}
                              </>
                            }
                          />
                        </ListItemButton>
                        <Collapse
                          in={openDD == i}
                          timeout="auto"
                          unmountOnExit
                          sx={{
                            boxShadow: openDD == i && "inset 1px 0px 0px #C4CBD4",
                          }}
                        >
                          <List component="div" disablePadding>
                            {item.group.map((element) => (
                              // FIX 4: Key on NextLink
                              <NextLink key={element.href} href={element.href}>
                                <ListItem
                                  sx={{
                                    padding: "4px 16px 4px 48px",
                                    margin: "none",
                                    ...(location === element.href && {
                                      color: "primary.main",
                                      backgroundColor: (theme) =>
                                        `${theme.palette.grey.bg20}!important`,
                                      borderLeft: (theme) =>
                                        `2px solid ${theme.palette.primary.main}`,
                                      borderRadius: "0px 8px 8px 0px",
                                    }),
                                  }}
                                  button
                                  selected={location === element.href}
                                >
                                  <ListItemText
                                    primary={
                                      <>
                                        <Typography
                                          variant="big"
                                          sx={{
                                            color: `${location === element.href ? "#2962FF" : ""
                                              }`,
                                          }}
                                        >
                                          {element.title}
                                        </Typography>
                                      </>
                                    }
                                  />
                                </ListItem>
                              </NextLink>
                            ))}
                          </List>
                        </Collapse>
                      </div>
                    )
                  )}
                </List>
              </Box>
            ))
            : Menuitems.map((Menuitem, index) => (
              <Box key={`user-menu-${index}`} sx={{ mb: "2em" }}>
                <Typography
                  sx={{
                    marginLeft: "1.5em",
                    fontSize: "10px",
                    marginY: "12px",
                  }}
                >
                  {Menuitem.subHead}
                </Typography>
                <List component="li" disablePadding>
                  {Menuitem.content.map((item, i) => {
                    const hasAccess =
                      item.type.includes(user?.type) &&
                      item?.role?.includes(user?.role?.id);

                    if (!item.group && hasAccess) {
                      // return (
                      //   <NextLink key={item.href || i} href={item.href ? item.href : ""}>
                      //     <ListItem
                      //       onClick={(e) => {
                      //         e.preventDefault();
                      //         e.stopPropagation();

                      //         console.log("Clicked item:", item);

                      //         if (item.action) {
                      //           callback(item.action);
                      //           return;
                      //         }

                      //         onSidebarClose();
                      //       }}
                      //       // onClick={() => item.action && callback(item.action)}
                      //       button
                      //       selected={location === item.href}
                      //       sx={{
                      //         margin: "none",
                      //         ...(location === item.href && {
                      //           color: "primary.main",
                      //           backgroundColor: (theme) =>
                      //             `${theme.palette.grey.bg20}!important`,
                      //           borderLeft: (theme) =>
                      //             `2px solid ${theme.palette.primary.main}`,
                      //           borderRadius: "0px 8px 8px 0px",
                      //         }),
                      //       }}
                      //     >
                      //       {item.icon && (
                      //         <ListItemIcon>
                      //           <i
                      //             className={item.icon}
                      //             style={{
                      //               color: `${location === item.href ? "#2962FF" : ""}`,
                      //             }}
                      //           ></i>
                      //         </ListItemIcon>
                      //       )}
                      //       <ListItemText
                      //         disableTypography
                      //         sx={{ margin: 0 }}
                      //         primary={
                      //           <>
                      //             <Typography
                      //               variant="big"
                      //               sx={{
                      //                 color: `${location === item.href ? "#2962FF" : ""}`,
                      //               }}
                      //             >
                      //               {item.title === "id" ? user?.donee_code : item.title}
                      //             </Typography>
                      //             {item.icon_right && (
                      //               <i
                      //                 className={item.icon_right}
                      //                 style={{
                      //                   marginLeft: "1em",
                      //                   color:
                      //                     location === item.href
                      //                       ? "#2962FF"
                      //                       : item.icon_color || "",
                      //                 }}
                      //               ></i>
                      //             )}
                      //           </>
                      //         }
                      //         onClick={onSidebarClose}
                      //       />
                      //     </ListItem>
                      //   </NextLink>
                      // );
                      return item.href ? (
                        <NextLink key={item.href || i} href={item.href}>
                          <ListItem
                            button
                            selected={location === item.href}
                            onClick={() => {
                              onSidebarClose();
                            }}
                            sx={{
                              margin: "none",
                              ...(location === item.href && {
                                color: "primary.main",
                                backgroundColor: (theme) =>
                                  `${theme.palette.grey.bg20}!important`,
                                borderLeft: (theme) =>
                                  `2px solid ${theme.palette.primary.main}`,
                                borderRadius: "0px 8px 8px 0px",
                              }),
                            }}
                          >
                            {item.icon && (
                              <ListItemIcon>
                                <i
                                  className={item.icon}
                                  style={{
                                    color: `${location === item.href ? "#2962FF" : ""}`,
                                  }}
                                ></i>
                              </ListItemIcon>
                            )}

                            <ListItemText
                              disableTypography
                              sx={{ margin: 0 }}
                              primary={
                                <>
                                  <Typography
                                    variant="big"
                                    sx={{
                                      color: `${location === item.href ? "#2962FF" : ""}`,
                                    }}
                                  >
                                    {item.title === "id" ? user?.donee_code : item.title}
                                  </Typography>

                                  {item.icon_right && (
                                    <i
                                      className={item.icon_right}
                                      style={{
                                        marginLeft: "1em",
                                        color:
                                          location === item.href
                                            ? "#2962FF"
                                            : item.icon_color || "",
                                      }}
                                    ></i>
                                  )}
                                </>
                              }
                            />
                          </ListItem>
                        </NextLink>
                      ) : (
                        <ListItem
                          key={i}
                          button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            if (item.action) {
                              onSidebarClose();
                              callback(item.action);
                            }
                          }}
                          sx={{
                            margin: "none",
                          }}
                        >
                          {item.icon && (
                            <ListItemIcon>
                              <i className={item.icon}></i>
                            </ListItemIcon>
                          )}

                          <ListItemText
                            disableTypography
                            sx={{ margin: 0 }}
                            primary={
                              <>
                                <Typography variant="big">
                                  {item.title === "id" ? user?.donee_code : item.title}
                                </Typography>

                                {item.icon_right && (
                                  <i
                                    className={item.icon_right}
                                    style={{
                                      marginLeft: "1em",
                                      color: item.icon_color || "",
                                    }}
                                  ></i>
                                )}
                              </>
                            }
                          />
                        </ListItem>
                      );
                    } else if (item.group && hasAccess) {
                      return (
                        <div key={`user-group-${i}`}>
                          <ListItemButton
                            onClick={() => handleClickDD(i)}
                            sx={{
                              boxShadow: openDD == i && "inset 1px 0px 0px #C4CBD4",
                              margin: "none",
                              paddingY: "4px",
                            }}
                          >
                            <ListItemIcon>
                              <i
                                className={item.icon}
                                style={{
                                  color: `${location === item.href ? "#2962FF" : ""}`,
                                }}
                              ></i>
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <>
                                  <Typography variant="big">
                                    {item.title === "id" ? user?.donee_code : item.title}
                                  </Typography>
                                  {item.icon_right && (
                                    <i
                                      className={item.icon_right}
                                      style={{ marginLeft: "1em" }}
                                    ></i>
                                  )}
                                </>
                              }
                            />
                            <ListItemIcon>
                              <i
                                className={
                                  openDD == i ? "las la-angle-up la-md" : "las la-angle-down la-md"
                                }
                                style={{
                                  color: `${location === item.href ? "#2962FF" : ""}`,
                                }}
                              ></i>
                            </ListItemIcon>
                          </ListItemButton>
                          <Collapse in={openDD == i} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              {item.group.map((element) => (
                                <NextLink key={element.href} href={element.href}>
                                  <ListItem
                                    button
                                    selected={location === element.href}
                                    sx={{
                                      padding: "4px 16px 4px 48px",
                                      margin: "none",
                                      ...(location === element.href && {
                                        color: "primary.main",
                                        backgroundColor: (theme) =>
                                          `${theme.palette.grey.bg20}!important`,
                                        borderLeft: (theme) =>
                                          `2px solid ${theme.palette.primary.main}`,
                                        borderRadius: "0px 8px 8px 0px",
                                      }),
                                    }}
                                  >
                                    <ListItemText
                                      primary={
                                        <>
                                          <Typography
                                            variant="big"
                                            sx={{
                                              color: `${location === element.href ? "#2962FF" : ""
                                                }`,
                                            }}
                                          >
                                            {element.title}
                                          </Typography>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                </NextLink>
                              ))}
                            </List>
                          </Collapse>
                        </div>
                      );
                    }
                    return null;
                  })}
                </List>
              </Box>
            ))}
        </List>
      </Box>
      <Box p={2}>
        <ContactModal />
      </Box>
    </Box>
  );
  if (lgUp) {
    return (
      <>
        <Drawer
          anchor="left"
          open={isSidebarOpen}
          variant="persistent"
          sx={{ displayPrint: "none" }}
          PaperProps={{
            sx: {
              width: "265px",
              border: "0 !important",
              pt: "64px",
              background: "inherit",
              displayPrint: "none",
            },
          }}
        >
          {SidebarContent}
        </Drawer>
        <QrModal show={open} setShow={setOpen} />
        {/* <StripeModal show={openStripe} setShow={setOpenStripe} /> */}
        {openStripe && (
          <StripeModal
            show={openStripe}
            setShow={setOpenStripe}
          />
        )}
      </>
    );
  }
  return (
    <>
      <Drawer
        anchor="left"
        open={isMobileSidebarOpen}
        onClose={onSidebarClose}
        sx={{ displayPrint: "none" }}
        PaperProps={{
          sx: {
            width: "265px",
            border: "0 !important",
            flexShrink: 0,
            displayPrint: "none",
          },
        }}
        variant="temporary"
      >
        {SidebarContent}
      </Drawer>
      <QrModal show={open} setShow={setOpen} />
      {/* <StripeModal show={openStripe} setShow={setOpenStripe} /> */}
      {openStripe && (
        <StripeModal
          show={openStripe}
          setShow={setOpenStripe}
        />
      )}
    </>
  );
};

Sidebar.propTypes = {
  isMobileSidebarOpen: PropTypes.bool,
  onSidebarClose: PropTypes.func,
  isSidebarOpen: PropTypes.bool,
};

export default Sidebar;
